const errorCode = {
    0: '操作成功',
    1: '参数不对',
    2: '非法请求',
    3: '必填字段不能为空',
    101: '用户名错误',
    102: '密码错误',
    103: '用户不存在',
    104: '昵称已被使用',
    105: '用户已登录',
    106: '用户未登录',
    109: '图形验证码错误',
    111: '验证码错误',
    128: '微信code过期',
    401: '登录过期，请重新登录',
    6002: '商品已下架！',
    7001: '当前活动已结束',
    9001: '该商品已失效，无法访问',
    9002: '暂无门店销售此商品',
    9003: '很抱歉，您访问的页面失效了'
}

export default errorCode
